import styled from 'styled-components';
import {BLACK, BLACK_300, GREY_2, GREY_4, GREY_7, PRIMARY} from "../../../utils/colors";
import device from "../../../utils/mediaQuery";

export const Container = styled.section`
  background: #fff;
  padding: 20px;
    
    .ant-modal {
        top: 20px;
    }
`;

export const Wrapper = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 40px 20px 16px 20px;
  background: #fff;
  column-gap: 10px;
  
    @media ${device.large} {
      padding: 0;
      background: unset;
    }
`;

export const TextContent = styled.div`
  text-align: center;
  flex: 1;
  text-transform: capitalize;
`;

export const DetailsWrapper = styled.div`
    display: flex;
    column-gap: 10px;
    align-items: center;

      svg {
        path {
          fill: ${BLACK_300} !important;
        }
      }

  @media ${device.large} {
    column-gap: 20px;
  }
`;

export const EditIconWrapper = styled.div`
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${PRIMARY};
  border-radius: 50%;
  width: 32px;
  height: 32px;
  
  svg {
    cursor: pointer;
    width: 16px;
    height: 16px;
    path {
      fill: #fff !important; /* White icon inside orange button */
    }
  }
`;


export const SearchSummaryPill = styled.div`
  border-radius: 100px;
  border: 1px solid ${GREY_4};
  background: #fff;
  padding: 6px 6px 6px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  margin: 0 10px;
`;

export const FilterIconButton = styled.div`
  border-radius: 50%;
  border: 1px solid ${GREY_4};
  background: #fff;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  svg {
    path {
      fill: ${BLACK} !important;
    }
  }
`;
export const BackIconWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  column-gap: 10px;
  
  svg {
    path {
      fill: ${BLACK} !important;
    }
  }
`;
export const NavImageIcon = styled.img`
  width: 15px;
  height: 15px;
  padding: 10px;
  box-sizing: content-box;
  background: #fff;
  border-radius: 5px;
  cursor: pointer;
`;

export const FormFieldsWrapper = styled.div`
  .ant-form-item {
    margin-bottom:12px;
  }
`;

export const DrawerContent = styled.div`
  min-height: 300px;
`;


export const SearchContainer = styled.div`
  flex: 1;
    text-align: center;
    border: 1px solid ${GREY_7};
    border-radius: 100px;
    padding: 10px;
    max-width: 70%;
    min-width: 50%;
    margin: 0 auto;
    
`;


export const SearchItemWrapper = styled.div`
    border-left: solid 2px ${GREY_7};
    padding: 8px 16px;
    display: flex;
    align-items: center;
    column-gap: 5px;
`;


export const SearchWrapper = styled.div`
    display: inline-flex;
    column-gap: 12px;
    cursor: pointer;
    align-items: center;
    justify-content: center;
  
    ${SearchItemWrapper} {
      &:first-of-type {
        border-left: none;
      }
    }
`;
